import { Post } from 'api/index'
import { toast } from 'react-toastify'
import { t } from 'ttag'
import getBackendURL from 'util/backend-url'

export const APPLY_SEARCH = 'APPLY_SEARCH'
export const APPLY_DOCUMENT_SEARCH = 'APPLY_DOCUMENT_SEARCH'
export const TOGGLE_DOCUMENTS_VISIBLE = 'TOGGLE_DOCUMENTS_VISIBLE'
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS'
export const APPLY_HEAT_MAP_SEARCH = 'APPLY_HEAT_MAP_SEARCH'
export const GET_HEAT_MAP_PARTNERSHIPS = 'GET_HEAT_MAP_PARTNERSHIPS'
export const SET_MAP_DOWNLOAD_LOADING = 'SET_MAP_DOWNLOAD_LOADING'
export const SAVE_SEARCH = 'SAVE_SEARCH'
export const SAVE_DOCUMENT_SEARCH = 'SAVE_DOCUMENT_SEARCH'

export const applySearch = data => dispatch => {
  const { currentSearchable, body, page, orderby } = data
  let url = `/api/search/${currentSearchable}/`
  if (page && !orderby) {
    url = `/api/search/${currentSearchable}/?page=${page}`
  }
  if (page && orderby) {
    url = `/api/search/${currentSearchable}/?page=${page}&orderby=${orderby}`
  }
  if (currentSearchable === 'countries_and_regions') {
    url = `/api/search/programmes/`
    if (body.programmes.nuts.length > 0) {
      return dispatch({
        type: APPLY_SEARCH,
        payload: Post(
          url,
          JSON.stringify({
            ...body,
            'no-pagination': true
          })
        )
      })
    }
  }
  return dispatch({
    type: APPLY_SEARCH,
    payload: Post(url, JSON.stringify(body))
  })
}

export const applyDocumentSearch = data => dispatch => {
  const { body, page } = data
  let url = `/api/search/project-attachments/`
  if (page) {
    url = `/api/search/project-attachments/?page=${page}`
  }
  return dispatch({
    type: APPLY_DOCUMENT_SEARCH,
    payload: Post(url, JSON.stringify(body))
  })
}

export const applyHeatMapSearch = data => dispatch => {
  const { body } = data
  const url = `/api/search/heatmap/`
  return dispatch({
    type: APPLY_HEAT_MAP_SEARCH,
    payload: Post(url, JSON.stringify(body))
  })
}

export const getHeatMapPartnerships = data => dispatch => {
  const { body } = data
  const url = `/api/search/heatmap/partnerships/`
  return dispatch({
    type: GET_HEAT_MAP_PARTNERSHIPS,
    payload: Post(url, JSON.stringify(body))
  })
}

export const downloadDocumentFile = data => () => {
  const { id, fileName } = data
  const apiUrl = getBackendURL()
  const xhr = new XMLHttpRequest()
  xhr.onreadystatechange = () => {
    let a
    if (xhr.readyState === 4 && xhr.status === 200) {
      a = document.createElement('a')
      a.href = window.URL.createObjectURL(xhr.response)
      a.download = fileName
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
    }
  }
  xhr.responseType = 'blob'
  xhr.open('GET', `${apiUrl}/api/project-attachment/${id}/get_file`)
  xhr.send()
  xhr.onerror = () => {
    toast.error(t`An error occurred when trying to download the file`)
  }
}

export const toggleDocumentsVisible = data => dispatch =>
  dispatch({
    type: TOGGLE_DOCUMENTS_VISIBLE,
    payload: data
  })

export const clearSearchResults = () => dispatch =>
  dispatch({
    type: CLEAR_SEARCH_RESULTS
  })

export const setMapDownloadLoading = data => dispatch =>
  dispatch({
    type: SET_MAP_DOWNLOAD_LOADING,
    payload: data
  })

export const saveSearch = data => dispatch => {
  dispatch({
    type: SAVE_SEARCH,
    payload: data
  })
}

export const saveDocumentSearch = data => dispatch => {
  dispatch({
    type: SAVE_DOCUMENT_SEARCH,
    payload: data
  })
}
